import { useState } from 'react';

import menuBurger from '../../../../assets/img/png/health-monitor/menu-burger.png';
import magnifier from '../../../../assets/img/png/health-monitor/magnifier.png';
import magnifierWhite from '../../../../assets/img/png/health-monitor/magnifier-white.png';
import { setSearchInput } from '../../../../store/slice/health-monitor/device-list';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { useAppSelector } from '../../../../hook/useAppSelector';
import MobileFilters from '../../Header/Filters/MobileFilters';

interface Props {
  setShouldShowSearchBar: React.Dispatch<React.SetStateAction<boolean>>;
  setShouldShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
  setAnimateIn: React.Dispatch<React.SetStateAction<boolean>>;
  isMenuButtonActive: boolean;
  onMenuButtonClick: () => void;
  setIsMenuButtonActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileButtons: React.FC<Props> = ({
  setShouldShowSearchBar,
  isMenuButtonActive,
  onMenuButtonClick,
  setIsMenuButtonActive,
}) => {
  const [isSearchButtonActive, setIsSearchButtonActive] = useState(false);
  const filterType = useAppSelector((state) => state.globalFilters.filterType);
  const dispatch = useAppDispatch();

  const onSearchButtonClick = () => {
    setIsSearchButtonActive((prev) => !prev);
    if (isSearchButtonActive) {
      dispatch(setSearchInput(''));
    }
    setIsMenuButtonActive(false);
    setShouldShowSearchBar((prev) => !prev);
  };

  return (
    <div className="header_buttons">
      <button
        className={`search ${isSearchButtonActive ? 'active' : null}`}
        onClick={() => {
          onSearchButtonClick();
        }}
      >
        {isSearchButtonActive ? <img src={magnifierWhite} alt="magnifier" /> : <img src={magnifier} alt="magnifier" />}
      </button>

      {filterType && <MobileFilters></MobileFilters>}

      <button
        className={`menu ${isMenuButtonActive ? 'hidden' : null}`}
        onClick={() => {
          onMenuButtonClick();
        }}
      >
        <img src={menuBurger} alt="menu burger" />
      </button>
    </div>
  );
};

export default MobileButtons;
